import React, { useMemo, useCallback, useState } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";

import { QUESTION_TYPE_IDS, EMPTY_STRING, SAVE } from "../../../../constants";
import RichTextEditor from "../../../../shared/components/Editor/RichTextEditor";
import {
  formatTextToHtml,
  getFormattedHtml,
} from "../../../../shared/utility";
import DetailRow from "./DetailRow";
import { eventBookingActions } from "../../../../redux/actions";

// Modal for showing the details of reels (recap brief)
const EventDetailsModal = ({
  className,
  eventDetail,
  eventDetailId,
  isModalOpen,
  handleModalClose,
  updateEventShotList,
  isShotListEditable = false,
}) => {
  const initialShotListContent = useMemo(() => {
    const description = eventDetail?.eventType?.description || EMPTY_STRING;
    return formatTextToHtml(description);
  }, [eventDetail]);

  const eventTypeId = useMemo(() => {
    return eventDetail?.eventType?.id || null;
  }, [eventDetail]);

  const [currentContent, setCurrentContent] = useState(initialShotListContent);

  const handleContentChange = useCallback((content) => {
    setCurrentContent(content);
  }, []);

  const handleSave = useCallback(async () => {
    if (!eventTypeId) return;

    await updateEventShotList({
      eventTypeId: eventTypeId,
      description: currentContent,
    });
    handleModalClose();
  }, [eventTypeId, currentContent, handleModalClose]);

  return (
    <Modal
      isOpen={isModalOpen}
      className={className}
      onRequestClose={handleModalClose}
    >
      <div className="main-con">
        <div className="row">
          {/* Header */}
          <div className="row w-100 header">
            <div className="col-12">shot list</div>
            <div className="col-12">{eventDetailId}</div>
          </div>
          {/* Details */}
          <div className="w-100 my-3">
            <>
              <DetailRow
                label="event type:"
                value={eventDetail?.eventType?.name}
              />
              <DetailRow
                label="event overview:"
                value={
                  eventDetail?.eventQuestionAnswers?.find(
                    (f) => f.questionTypeId == QUESTION_TYPE_IDS.CONTENT_USAGE
                  )?.answer ?? " "
                }
              />
              {/* shot list (Markdown + HTML Support) */}
              <div className="row w-100">
                <div className="col-12 col-md-4 col-lg-3 col-xl-2 py-1 py-md-2 detail-row-heading">
                  event shot list:
                </div>
                {isShotListEditable ? (
                  <div className="event-shot-list-editor">
                    <RichTextEditor
                      onContentChange={handleContentChange}
                      initialContent={initialShotListContent}
                    />
                  </div>
                ) : (
                  <div
                    className="col-12 col-md-8 col-lg-9 col-xl-10 py-1 py-md-2 formatted-html"
                    dangerouslySetInnerHTML={getFormattedHtml(
                      initialShotListContent
                    )}
                  />
                )}
              </div>
              <DetailRow
                label="brand & legal requirements:"
                value={
                  eventDetail?.eventQuestionAnswers?.find(
                    (f) =>
                      f.questionTypeId == QUESTION_TYPE_IDS.BRAND_GUIDELINES
                  )?.answer ?? " "
                }
              />
            </>
          </div>
        </div>
        {isShotListEditable && (
          <div className="d-flex justify-content-center w-100 mt-3">
            <button
              type="button"
              className="button-common button-fill"
              onClick={handleSave}
            >
              {SAVE}
            </button>
          </div>
        )}
        <button onClick={handleModalClose} className="modal-close">
          <img
            alt="crossIcon"
            className="modal-close-img"
            src="/images/simpleCrossWhite.svg"
          />
        </button>
      </div>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updateEventShotList: (data) =>
    dispatch(eventBookingActions.updateShotList(data)),
});

export default connect(null, mapDispatchToProps)(EventDetailsModal);
